import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setSessionCookie } from '../../utils/sessionCookie'
import { useDispatch } from 'react-redux'
import { cabAction } from '../../store/Cab/CAbReducer'
import { clearSessionStorageSafe, removeCabSearchResult } from '../../utils/clientStorage'
import Navbar from '../../layout/Navbar'
import Main from './Main'
// import ServiceSection from './ServiceSection'
import StatisticSection from './StatisticSection'
import PopularRoutes from './PopularRoutes'
import PopularLinks from './PopularLinks'
import RouteShowcase from './RouteShowcase'
// import BlogSection from './BlogSection'
import WhyChooseUs from './WhyChooseUs'
import Testimonials from './Testimonials'
import MediaCoverage from './MeidaCoverage'
// import DownloadSection from '../../layout/downloadSection'
import Footer from '../../layout/Footer'
import SEO, { getSEOData } from '../../components/SEO'
import Schema from '../../components/Schema'

function Home() {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    setSessionCookie()
  }, [])

  useEffect(() => {
    clearSessionStorageSafe()
    removeCabSearchResult()
    dispatch(cabAction.resetCabBookingContext())
  }, [dispatch])

  const seo = getSEOData('home');
  const routePrefill = location.state?.routePrefill || null

  return (
    <div className='home'>
      <SEO
        title={seo.title.replace(' | Pulpit', '').replace('Pulpit - ', '')}
        description={seo.description}
        keywords={seo.keywords}
      />
      {/* The homepage is the entity anchor; the Organization node previously
          rendered only on the Corporate page. */}
      <Schema type="organization" />
      <Navbar page='home'></Navbar>
      <Main routePrefill={routePrefill}></Main>
      <RouteShowcase
        heading="One Way Outstation Cab Booking Across India"
        subheading="Book intercity cabs in 450+ cities at transparent per-kilometre fares. Verified drivers, clean cars, and no hidden charges on one-way or round trips."
      />
      {/* <ServiceSection></ServiceSection> */}
      <PopularRoutes />
      <StatisticSection></StatisticSection>
      {/* <BlogSection></BlogSection> */}
      {/* <Client></Client> */}

      <PopularLinks />
      <MediaCoverage ></MediaCoverage>
      <WhyChooseUs></WhyChooseUs>
      <Testimonials></Testimonials>
      {/* <Review></Review> */}

      {/* <DownloadSection></DownloadSection> */}
      <Footer></Footer>
    </div>
  )
}

export default Home